module.exports = __webpack_public_path__ + "img/market.e8aca78f.svg";